





















































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";
import { MessageBox } from "element-ui";

import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetAudioQualityScriptListReq,
  Bool,
  OpenTicketReq,
  AudioQualityScriptData,
  SaveAudioQualityScriptReq,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "addnewTalkPoint",
  components: {
    MaskComponent: () => import("./Mask.vue"),
  },
})
export default class addnewTalkPoint extends Vue {
  @Prop() flag: any;
  @Prop() dataRes: any;
  @Prop() part: any;
  @Prop() selectText: any;
  @Prop() timestart: any;
  @Prop() timeend: any;
  @Prop() selectTextId: any;
  @Prop() Copywritingindex: any;

  @Provide() private audioPlayLoading: boolean = false;
  @Provide() private userForm: any = {
    TalkPointName: null,
    keywordsPhrases: null,
  };
  @Provide() private dynamicTags: any = [];
  @Provide() private correctcopywriting: any = "";
  @Provide() private correctcopywritingB: any = "";
  @Provide() private inputVisible: boolean = false;
  @Provide() private showDialogTypeId: number = 0;
  @Provide() private inputValue: any = "";

  //   private created(){
  //       this.addNewPoint(this.flag,this.dataRes)
  //   }
  @Watch("flag")
  onAmountChanged(val: number | null) {
    this.correctcopywriting = "";
    if (val !== -7) {
      this.showDialogTypeId = this.dataRes.id;
      this.userForm.TalkPointName = this.dataRes.scriptname;
      this.dynamicTags = this.dataRes.scripttextList.split(",");
    } else {
      this.showDialogTypeId = -1;
      this.userForm.TalkPointName = "";
      this.dynamicTags = [];
    }
  }
  private handleClose(tag: any) {
    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
  }

  private showInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus();
      // this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  private hideMaskVue() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: null,
    });
  }
  private open() {
    this.$confirm(this.$tc("dashbordDy.previouspage"), "提示", {
      confirmButtonText: this.$tc("dashbordDy.confirmreturn"),
      cancelButtonText: this.$tc("dashbordDy.continueediting"),
      type: "warning",
    })
      .then(() => {
        this.closeDialog();
        // this.submitPoint();
        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // });
      })
      .catch(() => {
        // this.closeDialog();
        // this.$message({
        //   type: "info",
        //   message: "已取消删除",
        // });
      });
  }
  private closeDialog() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: 0,
    });
  }
  private audioPlay(val: any, index: any, timeend: any) {
    this.$emit("audioPlay1", { val: val, index: index, timeend: timeend });
  }
  private testRule() {
    if (this.correctcopywriting) {
      return true;
    } else {
      this.$message({
        type: "error",
        message: "pls check the form value!",
      });
      return false;
    }
  }
  //保存对象
  private saveObj() {
    this.correctcopywritingB = this.correctcopywriting;
    this.$emit("saveAudioMarkText", { val: true });
  }
  //baocun
  private submitPoint() {
    if (this.testRule()) {
      this.saveObj();
      this.$message.success("success");
      this.correctcopywriting = "";
      this.closeDialog();
    }
  }
}
